export const PadithiEnum = Object.freeze({
  MASTER: "MASTER",
  LAL_KITAB: "LAL_KITAB",
  NADI: "NADI",
  PARASHARA: "PARASHARA",
  JAIMINI : 'JAIMINI',
//   KP : 'KP',
});

export const CategoryType =  Object.freeze({
  PROMISE: "PROMISE",
  KEY: "KEY",
  CAREER: "CAREER",
  RELATIONSHIP: "RELATIONSHIP",
  FINANCE: "FINANCE",
  HEALTH: "HEALTH",
  LEGAL: "LEGAL",
  EDUCATION: "EDUCATION",
  COMFORT: "COMFORT",
  FAMILY: "FAMILY",
  REMEDY: "REMEDY",
  CAUTION: "CAUTION",
  TAG: "TAG",
  DAY : 'DAY'
})

export const PredictionType =  Object.freeze({
  YEAR : 'YEAR',
  MONTH : 'MONTH',
  DAY : 'DAY'
})

export const NadiType = Object.freeze({
  NADI : 'NADI',
  NADI_DEGREE : 'NADI_DEGREE',
})

export const JaiminiType = Object.freeze({
  MAHADASHA: 'MAHADASHA',
  ANTRADASHA: 'ANTRADASHA',
});


export const MDADPredictionType = Object.freeze({
  MD : 'MD',
  AD : 'AD',
})

export const OpenAiPromptType = Object.freeze({
  PROFILE: 'PROFILE',
  GENERAL_CONDITIONS: 'GENERAL_CONDITIONS',
  YEARLY_PREDICTION: 'YEARLY_PREDICTION',
  MONTHLY_PREDICTION: 'MONTHLY_PREDICTION',
  DAY_PREDICTION: 'DAY_PREDICTION',
  PROMISE: 'PROMISE',
  KEY: 'KEY',
  CAUTION_PREDICTION: 'CAUTION_PREDICTION',
  REMEDY_PREDICTION: 'REMEDY_PREDICTION',
  CHATBOT_MODE: 'CHATBOT_MODE',
  PREDICTION_METER: 'PREDICTION_METER',
});

export const DivisionalChartType = Object.freeze({
  CHATURTHAMSA : 'CHATURTHAMSA',
  SAPTAMSA : 'SAPTAMSA',
  NAVAMSA : 'NAVAMSA',
  DASAMSA : 'DASAMSA',
  DWADAMSA : 'DWADAMSA',
})

export const SIGN_NAME_TO_SIGN_NUMBER = Object.freeze({
  ARIES: 1,
  TAURUS: 2,
  GEMINI: 3,
  CANCER: 4,
  LEO: 5,
  VIRGO: 6,
  LIBRA: 7,
  SCORPIO: 8,
  SAGITTARIUS: 9,
  CAPRICORN: 10,
  AQUARIUS: 11,
  PISCES: 12,
});

export const MonthEnum = Object.freeze({
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
  CURRENT_MONTH: "CURRENT_MONTH",
});


